/**
* DevExpress HTML/JS Reporting (common\defaultCulture.js)
* Version:  23.2.13
* Build date: Apr 29, 2025
* Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { createGlobalModuleVariableFunc } from '@devexpress/analytics-core/analytics-internal-native';
export const defaultCulture = 'Default';
export const availableCultures = createGlobalModuleVariableFunc({
    'Default': '(Default)'
});
